export class IFiatCurrency
{
    public currency: string;
    public symbol: string;
    constructor(){
        this.currency = '';
        this.symbol = '';
    }
}